import { render } from "./BaseListItemSection.vue?vue&type=template&id=f49d1346"
import script from "./BaseListItemSection.vue?vue&type=script&lang=js"
export * from "./BaseListItemSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/user-web-app/user-web-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__